import * as models from '../../domain/models';
import * as actions from '../actions/flight-contract';

export interface State {
  isPdfLoading: boolean;
  credits: models.Credits;
  isCreditsLoading: boolean;
  isCreditsLoaded: boolean;
  paymentTypes: models.OfferContractPaymentType[];
  isPaymentTypesLoading: boolean;
  isPaymentTypesLoaded: boolean;
  isContractSubmitting: boolean;
  isContractSubmitted: boolean;
  submitContractError: string;
}

const initialState: State = {
  isPdfLoading: false,
  credits: null,
  isCreditsLoading: false,
  isCreditsLoaded: false,
  paymentTypes: [],
  isPaymentTypesLoading: false,
  isPaymentTypesLoaded: false,
  isContractSubmitting: false,
  isContractSubmitted: false,
  submitContractError: null,
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.GET_FLIGHT_CONTRACT_PDF: {
      return { ...state, isPdfLoading: true };
    }
    case actions.GET_FLIGHT_CONTRACT_PDF_SUCCESS:
    case actions.GET_FLIGHT_CONTRACT_PDF_FAIL: {
      return { ...state, isPdfLoading: false };
    }
    case actions.GET_CREDITS: {
      return { ...state, isCreditsLoading: true, isCreditsLoaded: false };
    }
    case actions.GET_CREDITS_SUCCESS: {
      return { ...state, isCreditsLoading: false, isCreditsLoaded: true, credits: action.payload };
    }
    case actions.GET_CREDITS_FAIL: {
      return { ...state, isCreditsLoading: false, isCreditsLoaded: false };
    }
    case actions.GET_PAYMENT_TYPES: {
      return { ...state, isPaymentTypesLoading: true, isPaymentTypesLoaded: false };
    }
    case actions.GET_PAYMENT_TYPES_SUCCESS: {
      return { ...state, isPaymentTypesLoading: false, isPaymentTypesLoaded: true, paymentTypes: action.payload };
    }
    case actions.GET_PAYMENT_TYPES_FAIL: {
      return { ...state, isPaymentTypesLoading: false, isPaymentTypesLoaded: false };
    }
    case actions.SUBMIT_CONTRACT: {
      return { ...state, isContractSubmitting: true, isContractSubmitted: false, submitContractError: null };
    }
    case actions.SUBMIT_CONTRACT_SUCCESS: {
      return { ...state, isContractSubmitting: false, isContractSubmitted: true, submitContractError: null };
    }
    case actions.SUBMIT_CONTRACT_FAIL: {
      return { ...state, isContractSubmitting: false, isContractSubmitted: false, submitContractError: action.payload };
    }
    case actions.RESET_SUBMIT_CONTRACT_STATE: {
      return { ...state, isContractSubmitting: false, isContractSubmitted: false, submitContractError: null };
    }
    default:
      return state;
  }
}

export const getIsPdfLoading = (state: State) => state.isPdfLoading;
export const getCredits = (state: State) => state.credits;
export const getIsCreditsLoading = (state: State) => state.isCreditsLoading;
export const getIsCreditsLoaded = (state: State) => state.isCreditsLoaded;
export const getPaymentTypes = (state: State) => state.paymentTypes;
export const getIsPaymentTypesLoading = (state: State) => state.isPaymentTypesLoading;
export const getIsPaymentTypesLoaded = (state: State) => state.isPaymentTypesLoaded;
export const getIsContractSubmitting = (state: State) => state.isContractSubmitting;
export const getIsContractSubmitted = (state: State) => state.isContractSubmitted;
export const getSubmitContractError = (state: State) => state.submitContractError;
